import { createQueryKeys } from '@lukemorales/query-key-factory';

import API from '../../index';
import { CommonRequestParams } from 'api/api.types';

export const BRAND_DTO_ENUMS = {
  CATEGORY_ID: {
    /** 패션 */
    FASHION: 1,
    /** 뷰티 */
    BEAUTY: 2,
    /** F&B */
    FNB: 3,
    /** 호텔 */
    HOTEL: 4,
    /** 기타 */
    ETC: 10,
  },
  BUSINESS_TYPE: {
    /** 일반 */
    NORMAL: 'NORMAL',
    /** 동대문 */
    WHOLESALE: 'WHOLESALE',
    /** 뷰티 */
    BEAUTY: 'BEAUTY',
  },
  CURRENCY: {
    /** 원화 */
    KRW: 'KRW',
    /** 엔화 */
    JPY: 'JPY',
  },
  BILLING_TYPE: {
    FREE: 'FREE',
    PAID: 'PAID',
  },
} as const;

export const brandQueryKeys = createQueryKeys('brand', {
  getBrand: (params: CommonRequestParams) => ({
    queryKey: [{ params }],
    queryFn: () => API.Brand.getBrand(params),
  }),
});
